var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.locale ? _vm.$n(_vm.numericValue) : _vm.numericValue))]},{"number":_vm.tweenValue})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }